import React, {useState} from "react"
import {
    postSingleReservationRefundSettingData,
    postSingleReservationSettingData,
    reservationTableSetting
} from "../../../../../api/bookings"
import {Form, message} from "antd"
import moment from "moment"

/**
 * @typedef SettingType
 * @property {number} clubId
 * @property {number} tableId
 * @property {boolean} canReservation
 * @property {string} startTime
 * @property {string} endTime
 * @property {string} minReservationDuration
 * @property {boolean} needAutomaticAccept
 * @property {string} lockDuration
 * @property {boolean} isAutomaticRefund
 * @property {boolean} isEnabled
 * @property {number} id
 * @property {string} createTime
 * @property {string} updateTime
 */

/**
 * @typedef RefundType
 * @property {number} tableId
 * @property {number} type
 * @property {number} duration
 * @property {number} ratio
 * @property {boolean} isEnabled
 * @property {number} id
 * @property {string} createTime
 * @property {string} updateTime
 */

/**
 * @typedef PrepaidType
 * @property {number} clubId
 * @property {string} name
 * @property {number} amount
 * @property {number} duration
 * @property {boolean} isPurchaseLimitEnabled
 * @property {string} purchaseStartTime
 * @property {string} purchaseEndTime
 * @property {number} purchaseWeekday
 * @property {boolean} isEnabled
 * @property {number} id
 * @property {string} createTime
 * @property {string} updateTime
 * @property {boolean} canPurchase
 */


const initialState = {
    /**
     * @type {boolean}
     */
    isLoading: false,
    /**
     * @type {boolean}
     */
    isShowReserve: false,

    reservationSetting: {
        /**
         *@type SettingType
         */
        setting: {
            clubId: 0,
            tableId: 0,
            canReservation: false,
            startTime: '',
            endTime: '',
            minReservationDuration: 'PT30M',
            needAutomaticAccept: false,
            lockDuration: 'PT30M',
            isAutomaticRefund: false,
            isEnabled: false,
            id: -1,
            createTime: '',
            updateTime: '',
        },
        /**
         * @type {RefundType[]}
         */
        cancelFee: [],
        /**
         * @type {number[]}
         */
        tableIds: [],
        /**
         * @type {PrepaidType[]}
         */
        prepaids: []

    },
    getTableReservationProperty: (tableId) => {
    },
    updateTableReservationSetting: (tableId, callback) => {
    },
    getFieldValue: (name) => {
    },
}

export const ClubTableBookSettingContext = React.createContext(initialState)

export const ClubTableBookSettingProvider = ({children}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [reservationSetting, setReservationSetting] = useState(initialState.reservationSetting)
    const [form] = Form.useForm()
    const isShowReserve = Form.useWatch('canReservation', form)

    const getTableReservationProperty = async (tableId) => {
        setIsLoading(true)
        form.resetFields()
        await reservationTableSetting(tableId).then((res) => {
            if (res.data.length > 0) {
                setReservationSetting(res.data[0])
                const {setting, refunds} = res.data[0]
                form.setFieldsValue({
                    canReservation: setting.canReservation,
                    id: setting.id,
                    bookType: '1', // Assuming a default value for bookType
                    bookTime: [moment(setting.startTime, "HH:mm"), moment(setting.endTime, "HH:mm")],
                    minReservationDuration: setting.minReservationDuration,
                    needAutomaticAccept: setting.needAutomaticAccept,
                    isAutomaticRefund: setting.isAutomaticRefund,
                    isEnabled: setting.isEnabled,
                    lockDuration: setting.lockDuration,
                    cancelFee: refunds.map(item => ({
                        id: item.id,
                        ratio: (item.ratio * 100).toFixed(0),
                        duration: (item.duration / 60).toFixed(0),
                        type: item.type
                    }))
                })
                console.log("form", form)
            }
        }).catch((err) => {
            message.error(err.message)
        }).finally(() => {
            setIsLoading(false)
        })

    }

    const updateTableReservationSetting = async (tableIds, callback) => {
        try {
            if (isShowReserve) {
                let isValidate
                let values
                try {
                    values = await form.validateFields()
                    isValidate = true
                    console.log(values)
                } catch (e) {
                    message.error("部分表单没有填写完整")
                    console.log(e)
                    isValidate = false
                }
                if (!isValidate) {
                    return
                }

                const reservationProperty = {
                    canReservation: values.canReservation,
                    startTime: values.bookTime[0].format('HH:mm:ss'),
                    endTime: values.bookTime[1].format('HH:mm:ss'),
                    minReservationDuration: values.minReservationDuration ? values.minReservationDuration : 'PT30M',
                    needAutomaticAccept: values.needAutomaticAccept ? values.needAutomaticAccept : false,
                    lockDuration: values.lockDuration ? values.lockDuration : 'PT30M',
                    isAutomaticRefund: values.isAutomaticRefund ? values.isAutomaticRefund : false,
                    isEnabled: values.isEnabled ? values.isEnabled : true,
                    id: values.id,
                    clubId: parseInt(sessionStorage.getItem('club_id')),
                }
                let cancelFee = []
                if (values.cancelFee) {
                    cancelFee = values.cancelFee.map(item => ({
                        id: item.id ? item.id : -1,
                        ratio: item.ratio ? (item.ratio / 100).toFixed(2) : 0,
                        duration: item.duration ? (item.duration * 60).toFixed(0) : 0,
                        type: item.type ? item.type : 1,
                    }))
                }
                const settingReq = {
                    tableIds: tableIds,
                    data: reservationProperty,
                }

                const {status, detail} = await postSingleReservationSettingData(settingReq)
                if (status !== 1) {
                    message.error(`更新失败：${detail}`)
                }


                const cancelFeeReq = {
                    tableIds: tableIds,
                    data: [...cancelFee]
                }

                const {
                    status: refundStatus,
                    detail: refundDetail
                } = await postSingleReservationRefundSettingData(cancelFeeReq)

                if (refundStatus !== 1) {
                    message.error(`更新失败退款阶梯失败:${refundDetail}`)
                    return
                }
                message.success('更新成功')
                callback()
                form.resetFields()
            } else {
                const req = {
                    tableIds: tableIds,
                    data: null
                }
                const {status, detail} = await postSingleReservationSettingData(req)
                if (status !== 1) {
                    message.error(`更新失败:${detail}`)
                }
                message.success('更新成功')
                form.resetFields()
                callback()
            }

        } catch (e) {
            message.error(`发生错误：${e}`)
        }

    }

    const getFieldValue = (name) => {
        return form.getFieldValue(name)
    }


    const value = {
        isLoading,
        isShowReserve,
        form,
        reservationSetting,
        getTableReservationProperty,
        updateTableReservationSetting,
        getFieldValue,
    }


    return (
        <ClubTableBookSettingContext.Provider value={value}>
            {children}
        </ClubTableBookSettingContext.Provider>
    )
}

export const useClubTableBookSettingContext = () => {
    const context = React.useContext(ClubTableBookSettingContext)
    if (!context) {
        throw new Error("useClubTableBookSettingContext must be used within a ClubTableBookSettingProvider")
    }
    return context
}


// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/bookSettings/store/useClubTableBookSettingContext.js